import React, { useMemo } from "react";
import { Check, Minus, X } from "lucide-react";
import { evaluateRegistrationPassword } from "@tennis-matches/core/utils";

function __ruleState(hasInput, isMet) {
  if (!hasInput) return "neutral";
  return isMet ? "ok" : "fail";
}

function RuleIcon({ state }) {
  if (state === "ok") {
    return (
      <Check
        className="prWizard__passwordRuleIcon prWizard__passwordRuleIcon--ok"
        size={13}
        strokeWidth={2.5}
        aria-hidden
      />
    );
  }
  if (state === "fail") {
    return (
      <X
        className="prWizard__passwordRuleIcon prWizard__passwordRuleIcon--fail"
        size={13}
        strokeWidth={2.5}
        aria-hidden
      />
    );
  }
  return (
    <Minus
      className="prWizard__passwordRuleIcon prWizard__passwordRuleIcon--neutral"
      size={13}
      strokeWidth={2.5}
      aria-hidden
    />
  );
}

export function RegisterPasswordRules({
  t,
  password,
  passwordConfirm,
  compact = false,
}) {
  const checks = useMemo(
    () => evaluateRegistrationPassword(password, passwordConfirm),
    [password, passwordConfirm],
  );

  const minLengthState = __ruleState(checks.hasPasswordInput, checks.minLength);
  const matchState = __ruleState(checks.hasConfirmInput, checks.match);

  const rules = [
    {
      id: "minLength",
      state: minLengthState,
      labelKey: "auth.register.passwordRules.minLength",
    },
    {
      id: "match",
      state: matchState,
      labelKey: "auth.register.passwordRules.match",
    },
  ];

  return (
    <div
      className={`prWizard__passwordRulesWrap${compact ? " prWizard__passwordRulesWrap--compact" : ""}`}
    >
      {!compact ? (
        <p className="prWizard__passwordRulesTitle">
          {t("auth.register.passwordRules.title")}
        </p>
      ) : null}
      <ul
        className="prWizard__passwordRules"
        aria-label={t("auth.register.passwordRules.aria")}
      >
        {rules.map((rule) => (
          <li
            key={rule.id}
            className={`prWizard__passwordRule prWizard__passwordRule--${rule.state}`}
          >
            <RuleIcon state={rule.state} />
            <span>{t(rule.labelKey)}</span>
          </li>
        ))}
      </ul>
      {!compact && checks.allRequirementsMet ? (
        <p className="prWizard__passwordRulesSuccess">
          {t("auth.register.passwordRules.allOk")}
        </p>
      ) : null}
    </div>
  );
}
